import { render, staticRenderFns } from "./SkeletonProductMovil.vue?vue&type=template&id=1602b09b"
import script from "./SkeletonProductMovil.vue?vue&type=script&lang=js"
export * from "./SkeletonProductMovil.vue?vue&type=script&lang=js"
import style0 from "./SkeletonProductMovil.vue?vue&type=style&index=0&id=1602b09b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports